<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <template v-if="cashBoxConfig">
      <v-container>
        <ik-data-table
          ref="table"
          :model="model"
          entity-name="CashBox"
          icon="mdi-cash-usd"
        >
          <template
            #item.checkDetail="{item}"
          >
            <v-btn
              :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
              :icon="!$vuetify.breakpoint.lgAndUp"
              :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
              :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
              color="amber lighten-4 black--text"
              elevation="0"
              small
              @click.stop="goto(item)"
            >
              <template v-if="!$vuetify.breakpoint.lgAndUp">
                <v-icon color="white">
                  mdi-cog
                </v-icon>
              </template>
              <template v-if="$vuetify.breakpoint.lgAndUp">
                <div
                  :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                  :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
                >
                  {{ $t('Details') }}
                </div>
              </template>
            </v-btn>
          </template>
        </ik-data-table>
      </v-container>
    </template>
    <template v-else>
      <div
        class="d-flex justify-center align-center flex-column"
        style="height: 75vh"
      >
        <h1 class="text-h2 font-weight-black">
          404
        </h1>

        <div class="text-h4 mt-4">
          {{ $t('notEnabled') }} :(
        </div>
        <div class="mb-5 text-body-1">
          {{ $t('openSettingOrCallUs') }}
        </div>
      </div>
    </template>
    <v-dialog
      v-model="showDetailDialog"
      max-width="800px"
    >
      <v-card class="pa-8">
        <div class="text-h3 mb-4 d-flex align-center justify-center">
          <span>
            {{ $t('CashBox') }}:{{ boxInfo.name }}
          </span>
          <v-spacer />
          <v-btn
            icon
            @click="showDetailDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div>
          <v-data-table
            :headers="headers"
            :items="currentItems"
            :items-per-page="10"
            class="elevation-1"
          >
            <template #item.payLogAmount="{ item }">
              <v-chip
                :color="getColor(item.payLogAmount)"
                dark
              >
                {{ item.payLogAmount }}
              </v-chip>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import CashBox, { getBoxDetailCashList } from '@/model/dataLayer/api/CashBox/CashBox'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import i18n from '@/i18n'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      boxInfo: {},
      currentItems: [],
      headers: [
        {
          text: i18n.t('orderNumber'),
          value: 'orderId'
        },
        { text: i18n.t('TypeOfIncome'), value: 'cashInCome' },
        { text: i18n.t('detail'), value: 'name' },
        { text: i18n.t('note'), value: 'cashAccountNote' },
        { text: i18n.t('cash_amount'), value: 'payLogAmount' },
        { text: i18n.t('TimeStamp'), value: 'updateTimestamp' },
        { text: i18n.t('CashBox'), value: 'cashBoxId' }
      ],
      showDetailDialog: false,
      cashBoxConfig: false,
      model: CashBox
    })
  },
  async mounted () {
    await this.reload()
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getColor (payLogAmount) {
      if (payLogAmount > 0) return '#81C784'
      else return '#E57373'
    },
    async goto (item) {
      this.boxInfo = item
      this.currentItems = await getBoxDetailCashList(item.id, this.$parent.dateRange)
      this.showDetailDialog = true
    },
    async reload () {
      const res = await forceGetSystemSetting({
        section: 'CashBox',
        sKey: 'enabled',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.825',
        sOptions: '',
        tagList: 'basic,cash,box'
      })
      if (res === '1') {
        this.cashBoxConfig = true
      }
    }
  }
}
</script>
